import type { ApiClient } from './client';

export type SpeechKind = 'voice_s2s' | 'transcription';
export interface SpeechTool {
  kind: string;
  app_id: number | null;
  available: boolean;
  reason_code: string;
}
export interface SpeechForm {
  app_id: number;
  template_version: number;
  screen: string;
  available: boolean;
  expected_price: number;
  currency: string;
  chargeable: boolean;
  /** Цена единицы из прайса сервера: кадр/вариант/слайд («variant») или секунда результата («second») */
  unit_price?: number | null;
  unit_price_per?: 'variant' | 'second' | null;
  fields: Array<{
    key: string;
    type: string;
    required: boolean;
    values: string[];
    upload: { accept: string[]; max_duration_ms: number | null } | null;
  }>;
}
export interface SpeechCommand {
  screen: string;
  app_id: number;
  template_version: number;
  expected_price: number;
  inputs: Record<string, string>;
}
/** Съёмка фото передаётся объектом, остальные опубликованные поля остаются строками. */
export interface StudioCommand extends Omit<SpeechCommand, 'inputs'> {
  inputs: Record<string, string | Record<string, string>>;
}
export interface SpeechOrder {
  id: number;
  status: 'queued' | 'running' | 'done' | 'failed' | 'uncertain';
  error_code?: string | null;
  financial: { state: string; amount_tokens: string | null };
  result: {
    available: boolean;
    data?: unknown;
    text?: string;
    assets: Array<{ index: number; mime: string; file_name: string; has_audio?: boolean | null }>;
  } | null;
  result_revision: number;
}

/** Только опубликованные native-инструменты. Маршруты workflow n8n здесь не используются. */
export const speech = (client: ApiClient) => ({
  capabilities: (signal?: AbortSignal) => client.request<{ tools: SpeechTool[] }>('/app/capabilities', { signal }),
  form: (id: number, signal?: AbortSignal) => client.request<SpeechForm>(`/app/studio/apps/${id}/form`, { signal }),
  create: (body: SpeechCommand | StudioCommand, key: string, signal?: AbortSignal) =>
    client.request<SpeechOrder>('/app/orders', { method: 'POST', body, idempotency: key, signal }),
  get: (id: number, signal?: AbortSignal) => client.request<SpeechOrder>(`/app/orders/${id}`, { signal }),
  result: (order: SpeechOrder, index: number, signal?: AbortSignal) =>
    client.download(`/app/orders/${order.id}/result/files/${index}?revision=${order.result_revision}`, signal),
});
